<div class="fixed inset-0 z-50 grid place-items-center bg-black/50 backdrop-blur-sm p-4">
  <div class="w-full max-w-lg overflow-hidden rounded-2xl border border-border-color bg-white shadow-[0_12px_36px_var(--box-shadow-color)]">
    <header class="flex items-center justify-between bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-5 py-3 text-light-color">
      <div class="flex items-center gap-3">
        <i class="fa-regular fa-calendar-check text-lg"></i>
        <h2 class="text-base font-semibold">Atualizar Status do Agendamento</h2>
      </div>
      <button
        type="button"
        class="flex h-9 w-9 items-center justify-center rounded-full border border-white/30 bg-white/10 text-white transition hover:bg-white/20"
        (click)="handleCloseModal()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <main class="space-y-5 px-5 py-5">
      <div class="rounded-base border border-border-color bg-white p-4 shadow-sm">
        <div class="mb-3 flex items-center gap-3">
          <img
            src="https://api.dicebear.com/7.x/notionists/svg?scale=200&seed=872"
            alt="avatar"
            class="h-10 w-10 rounded-full border border-border-color bg-light-color object-cover" />
          <div class="text-sm text-dark-color">
            <div class="font-semibold">{{ dataAppointment.clientName }}</div>
            <div class="text-dark-color/70">{{ dataAppointment.clientPhone }}</div>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3 text-sm text-dark-color">
          <div>
            <p class="m-0 text-dark-color/70">Data</p>
            <p class="m-0 font-semibold">{{ dataAppointment.date | date: 'EEE dd/MM' | uppercase }}</p>
          </div>
          <div>
            <p class="m-0 text-dark-color/70">Horário</p>
            <p class="m-0 font-semibold">{{ dataAppointment.startTime }} - {{ dataAppointment.endTime }}</p>
          </div>
          <div>
            <p class="m-0 text-dark-color/70">Origem</p>
            <p class="m-0 font-semibold">{{ dataAppointment.origin }}</p>
          </div>
          <div>
            <p class="m-0 text-dark-color/70">Status Atual</p>
            <p class="m-0 font-semibold">{{ getStatusEnum(dataAppointment?.status) }}</p>
          </div>
        </div>
      </div>

      <form class="space-y-4">
        <div class="space-y-2">
          <label for="status-update" class="block text-sm font-medium text-dark-color">Novo Status</label>
          <select
            id="status-update"
            name="status"
            class="w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            [(ngModel)]="dataAppointment.status">
            <option value="scheduled">Agendado</option>
            <option value="rescheduled">Remarcado</option>
            <option value="canceled">Cancelado</option>
            <option value="confirmed">Confirmado</option>
            <option value="in_progress">Em Atendimento</option>
            <option value="completed">Finalizado</option>
            <option value="no_show">Faltou</option>
          </select>
        </div>

        <div class="space-y-2">
          <label for="notes-update" class="block text-sm font-medium text-dark-color">Observações</label>
          <textarea
            id="notes-update"
            rows="2"
            placeholder="Adicione alguma observação..."
            class="w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            [(ngModel)]="dataAppointment.notes"
            [ngModelOptions]="{ standalone: true }"></textarea>
        </div>

        <div class="flex flex-col gap-2 border-t border-border-color pt-3 md:flex-row md:justify-end">
          <button
            type="button"
            class="inline-flex items-center justify-center gap-2 rounded-base border border-border-color bg-white px-4 py-2 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color"
            (click)="handleCloseModal()">
            <i class="fa-solid fa-xmark"></i>
            Cancelar
          </button>
          <button
            type="button"
            class="inline-flex items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover"
            (click)="handleSubmit()">
            <i class="fa-solid fa-check"></i>
            Atualizar Status
          </button>
        </div>
      </form>
    </main>
  </div>
</div>

<app-loading-modal></app-loading-modal>
<app-alert></app-alert>
